import type { NodeExecution } from 'sprites-types/api/v2/workflows'
import { getToolResultSchema } from 'sprites-types/workflow/tools/common'
import { googleDriveMoveFile } from 'sprites-types/workflow/tools/googleDriveMoveFile'
import { MarkdownResult } from '../shared/MarkdownResult'
import { SchemaValidationError } from '../shared/safeParseToolResult'

interface Props {
  nodeExecution: NodeExecution
}

export function GoogleDriveMoveFileDisplay({ nodeExecution }: Props) {
  const schema = getToolResultSchema(googleDriveMoveFile, nodeExecution.inputs)
  const parseResult = schema.safeParse(nodeExecution.outputs)

  if (!parseResult.success) {
    return <SchemaValidationError error={parseResult.error} nodeExecution={nodeExecution} />
  }

  const result = parseResult.data

  return <MarkdownResult data={result} title="Google Drive: Move File" />
}
